import React from "react";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";
import headshot from './headshot.jpeg';

const MainTiltCard = () => {
  const x = useMotionValue(0);
  const y = useMotionValue(0);

  const mouseXSpring = useSpring(x);
  const mouseYSpring = useSpring(y);

  const rotateX = useTransform(
    mouseYSpring,
    [-0.5, 0.5],
    ["17.5deg", "-17.5deg"]
  );
  const rotateY = useTransform(
    mouseXSpring,
    [-0.5, 0.5],
    ["-17.5deg", "17.5deg"]
  );

  const handleMouseMove = (e) => {
    const rect = e.target.getBoundingClientRect();

    const width = rect.width;
    const height = rect.height;

    const mouseX = e.clientX - rect.left;
    const mouseY = e.clientY - rect.top;

    const xPct = mouseX / width - 0.5;
    const yPct = mouseY / height - 0.5;

    x.set(xPct);
    y.set(yPct);
  };

  const handleMouseLeave = () => {
    x.set(0);
    y.set(0);
  };

  return (
    <motion.div
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      style={{
        rotateY,
        rotateX,
        transformStyle: "preserve-3d",
      }}
      className="relative h-96 w-72 rounded-xl shadow-xl shadow-black/30 bg-gradient-to-br from-emerald-900 to-emerald-430 z-[1000]"
    >
      <div
        style={{
          transform: "translateZ(85px)",
          transformStyle: "preserve-3d",
        }}
        className="absolute inset-3 grid place-content-center rounded-xl bg-gradient-to-br from-emerald-200/75 to-emerald-100/75 shadow-lg z-10"
      >
        <img src={headshot} alt="Aldric Joya" style={{
            transform: "translateZ(60px)",
          }}className="rounded-full z-10"/>
        <p
          style={{
            transform: "translateZ(50px)",
          }}
          className="text-center text-2xl font-bold"
        >
          Aldric Joya
        </p>
        
      </div>
    </motion.div>
    
  );
};

export default MainTiltCard;